import { DomainInitPayload, Identity } from '@sxm-de/dev-kits/web-sdk/types';
import {
    getAuthTokenCookieValue,
    getAuthTokenParsed,
} from '@sxm-de/dev-kits/web-sdk/utils';

import { getIdentity } from '@sxm-de/dev-kits/web-sdk/domains/identity';

export type CheckIdentityStateAndLoginSMSIfAccountIdentityFn =
    () => Promise<void>;

export function initCheckIdentityStateAndLoginSMSIfAccountIdentity({
    dependencies,
}: DomainInitPayload): CheckIdentityStateAndLoginSMSIfAccountIdentityFn {
    const { microservicesSdk } = dependencies;
    return async () => {
        let identity: Identity;

        try {
            identity = await getIdentity(dependencies);
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }

        if (identity.state === 'STREAMING') {
            throw new Error('IDENTITY_NOT_ELIGIBLE_ERROR');
        }

        if (identity.state === 'ACCOUNT') {
            /**
             * TODO:
             * elevate getting identity grant into a helper function
             */
            const authToken = JSON.parse(getAuthTokenCookieValue() || '');
            if (!authToken) {
                throw new Error('SYSTEM');
            }
            const authTokenParsed = getAuthTokenParsed(authToken);
            const identityGrant = authTokenParsed?.identityGrant?.grant;
            if (!identityGrant) {
                throw new Error('SYSTEM');
            }
            try {
                /**
                 * confirm that the email being used is an email connected to the main SMS account
                 * exposes if the sms account is from a country different to the served app country
                 */
                await microservicesSdk.domains.authenticate.login({
                    identityGrant,
                });
            } catch {
                throw new Error('IDENTITY_NOT_ELIGIBLE_ERROR');
            }
        }
    };
}
